import PageData from "../PageData";

export class ContactFormTriggers {

    constructor(pageData: PageData) {
        this.setupEventListeners(pageData)
    }

    private setupEventListeners(pageData: PageData) {
        const contactForm = document.getElementById('adform-contact-form');
        const contactButton = document.getElementById('contact-button-unboosted-mobile');
        const toolbarContactButton = document.getElementById('footer-contact-bar-contact');
        const galleryContactButton = document.getElementById('go-to-form-nestoria-mobile');
        if (contactButton && contactForm && pageData.isBoosted) {
            contactButton.addEventListener('click', () => {
                contactForm.style.display = 'flex';
                contactButton.style.display = 'none';
            });
            if (toolbarContactButton) {
                toolbarContactButton.addEventListener('click', () => {
                    contactForm.style.display = 'flex';
                    contactButton.style.display = 'none';
                });
            }
            if (galleryContactButton) {
                galleryContactButton.addEventListener('click', () => {
                    contactForm.style.display = 'flex';
                    contactButton.style.display = 'none';
                    this.goToContactTab();
                });
            }
        }
    }

    private goToContactTab = () => {
        const event = new CustomEvent('contactTabClicked');
        document.dispatchEvent(event);
        this.goToSelectedTab();
    };

    private goToSelectedTab = () => {
        const tabsContainer = document.getElementById('contact-tabs-container')!;
        window.scrollTo(0, tabsContainer.offsetTop - 130);
    };
}